import React from "react";
import { useRemoteUsers } from "agora-rtc-react";
import { RemoteUser } from "agora-rtc-react";

const RemoteVideoView = () => {
    const remoteUsers = useRemoteUsers();

    return (
        <>
            {remoteUsers.map((user) => (
                <RemoteUser
                    key={user.uid}
                    audioTrack={user.audioTrack}
                    videoTrack={user.videoTrack}
                />
            ))}
        </>
    );
};

export default RemoteVideoView;
